import {Visitable} from './Visitable';
import {Visitor} from './Visitor';

import * as BookingTypes from '../types/BookingTypes';
import {isNullOrUndefined} from "../utils";
import dayjs from "dayjs";


export interface BookingInterface {
    testDate: dayjs.Dayjs;
    serverName: string;
    userId: number;
    created: dayjs.Dayjs;
    id: number;
    _links: any;
}

export class BookingConstraints {
  private _dnsSecAlg: number;
  private _domain: string;

  constructor(dnsSecAlg: number, domain: string) {
      this._dnsSecAlg = dnsSecAlg;
      this._domain = domain;
  }

  get dnsSecAlg(): number {
      return this._dnsSecAlg;
  }

  set dnsSecAlg(alg: number) {
      this._dnsSecAlg = alg;
  }

  set domain(domain: string) {
      this._domain = domain;
  }

  get domain(): string {
      return this._domain;
  }
}

/*
"constraints": {
    "dnsSecAlg": 2,
        "domain": "taranto-nickel.it"
},
*/

export class Booking implements Visitable {
    private _testDate: dayjs.Dayjs;
    private _serverName: string;
    private _userId: number;
    private _created: dayjs.Dayjs;
    private _linksObj: BookingTypes.Booking.Links;
    private _constraints?: BookingConstraints;
    private _id: number;
    private _hasResults: boolean;

    constructor(id: number, userId: number, testDate: dayjs.Dayjs,
                created: dayjs.Dayjs, serverName: string, links?: any) {
        this._testDate = dayjs(testDate);
        this._serverName = serverName;
        this._userId = userId;
        this._created = dayjs(created);
        this._linksObj = links;

        this._hasResults = ! isNullOrUndefined(links.result);

        this._id = id;
    }

    get testDate(): dayjs.Dayjs {
        return this._testDate;
    }

    get serverName(): string {
        return this._serverName;
    }

    get userId(): number {
        return this._userId;
    }

    get created(): dayjs.Dayjs {
        return this._created;
    }

    get links() {
        return this._linksObj;
    }

    set constraints(constraints: BookingConstraints | undefined) {
        this._constraints = constraints;
    }

    get constraints(): BookingConstraints | undefined {
        return this._constraints;
    }

    get id(): number {
        return this._id;
    }

    set id(id: number) {
        this._id = id;
    }

    get hasResults(): boolean {
        return this._hasResults;
    }

    accept(visitor: Visitor): void {
        visitor.visitBooking(this);
    }

}